import { Job, Job$Status } from '@Ravnur-Inc/shared/types/Job';

export function isRunningJob(job: Job): boolean {
  return job.state === Job$Status.RUNNING || job.state === Job$Status.QUEUED;
}
